// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disableMobilesBoard {
    max-height: 300px;
}

.disableMobilesBoard__contentContainer {
    text-align: center;
    vertical-align: middle;
}

.disableMobilesBoard__contentContainer__icon {
    width: 30px;
    height: 30px;
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/disableMobiles/DisableMobiles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".disableMobilesBoard {\n    max-height: 300px;\n}\n\n.disableMobilesBoard__contentContainer {\n    text-align: center;\n    vertical-align: middle;\n}\n\n.disableMobilesBoard__contentContainer__icon {\n    width: 30px;\n    height: 30px;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
